import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3d63e34"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "com_title1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "お気に入りページ （よく使う動画・資料）")
], -1))
const _hoisted_2 = { class: "com_topic_list1 com_more1" }
const _hoisted_3 = { class: "meta1" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "com_tag2" }
const _hoisted_6 = { class: "body1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.contentId,
          class: _normalizeClass({ disabled: _ctx.isProcessing })
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass({ com_favorite1: true, selected: item.isFavorite }),
              onClick: ($event: any) => (_ctx.handleToggleFavorite(item))
            }, null, 10, _hoisted_4),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.categoryName), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: `/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentId}`,
              class: "com_link1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ], 2))
      }), 128))
    ]),
    (!_ctx.showAll && _ctx.favoritPageListData.length > _ctx.showCount)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showAllItems && _ctx.showAllItems(...args))),
          class: "com_more_button1"
        }, " もっと見る "))
      : _createCommentVNode("", true)
  ], 64))
}